import { api } from "@/api";

import type { SaveAccessPayload } from "../types/access";

export const getAccessMatrix = async () => {
  const { data } = await api.getAccessMatrix();
  return data;
};

export const saveAccessChanges = async (payload: SaveAccessPayload) => {
  const data = await api.saveAccessChanges(payload);
  return data;
};

export const getMembers = async (groupId: string) => {
  const data = await api.msGroupMembers(groupId);
  return data as Array<{
    id: string;
    displayName: string;
    mail?: string;
    userPrincipalName: string;
  }>;
};

// GET user role assignments
export const getUserRoles = async (upn: string) => {
  return await api.getUserRoles(upn);
};

// POST user role assignments
export const saveUserRoles = async (payload: {
  user_principal_name: string;
  roles: { role_id: number; approval_type: "reviewer" | "approver" }[];
}) => {
  const data = await api.saveUserRoles(payload);
  return data;
};
